//@ts-nocheck
import React, { useContext, useState } from "react";
import { Box, Spinner, SystemProps } from "@storyofams/react-ui";
import { createClient } from "@supabase/supabase-js";

import { usePostHog } from "posthog-js/react";

import { useQuery } from "react-query";

import { shopifySdk } from "~lib/shopify/client";
import { ColorProvider, Divider, Text, UpsellModal } from "../../..";
import { useShopify } from "../../../../context";
import { ProductByHandleQuery } from "../../../../lib/shopify/sdk";
import { Button } from "../../../common/Button";

import { Timer } from "../../Timer";
import { CrowdFudningItem } from "./CrowdFundingItem";

interface Props {
  product: ProductByHandleQuery["productByHandle"];
  content: any;
}
export const CrowdFunding = React.memo(
  ({ product, content, ...props }: Props & SystemProps) => {
    const posthog = usePostHog();
    const { addItemToCart, updatingCart } = useShopify();
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [modal, showModal] = useState(null);
    const { color } = useContext(ColorProvider);
    const endDate = new Date(product.deadline.value);
    const targetValue = Number(product.targetRevenue.value).toFixed(0);
    const supabase = createClient(
      process.env.NEXT_PUBLIC_SUPABASE_URL,
      process.env.NEXT_PUBLIC_SUPABASE_KEY
    );
    const revenueCount = product?.revenueMarkup?.value
      ? Number(product.revenueMarkup.value)
      : 0;
    const { data: crowdfundData, isLoading } = useQuery(
      ["crowdfund", product],
      async () => {
        const { data } = await supabase
          .from("crowdfunding_analytics_view")
          .select("*")
          .eq("product_id", product.id);
        const uniqUsers = data[0].total_order_placed;
        const rased = (data[0].total_amount_raised + revenueCount).toFixed(0);
        const lastUsers = data[0].total_backers_in_last_24;
        return { data, uniqUsers, rased, lastUsers };
      },
      { refetchOnWindowFocus: false }
    );
    //@ts-ignore
    const { data: connectedProducts, isLoadingProducts } = useQuery(
      ["connectedProducts", product],
      async () => {
        const data = await shopifySdk.productsByIds({
          ids: JSON.parse(product?.connectedProducts?.value),
        });
        if (data?.nodes) {
          setSelectedProducts(
            data.nodes.map(({ variants, id }) => ({
              id: variants.edges[0].node.id,
              productId: id,
              quantity: 1,
              checked: true,
              compareAtPrice:
                variants?.edges[0]?.node?.compareAtPriceV2?.amount || 0,
              price: variants.edges[0].node.priceV2.amount,
            }))
          );
          return data.nodes;
        }
        return [];
      },
      {
        refetchOnWindowFocus: false,
        enabled: !!product?.connectedProducts?.value,
      }
    );
    const totalPrice = selectedProducts.reduce(
      (acc, item) => (item.checked ? acc + item.price * item.quantity : acc),
      0
    );
    const totalPricePerOne = selectedProducts.reduce(
      (acc, item) => acc + Number(item.price),
      0
    );
    const totalComparePrice = selectedProducts.reduce(
      (acc, item) =>
        item.checked ? acc + item.compareAtPrice * item.quantity : acc,
      0
    );
    const funded = Number(
      (Number(crowdfundData?.rased) / Number(targetValue)) * 100
    ).toFixed(2);
    const orders =
      crowdfundData?.uniqUsers +
      (revenueCount ? Math.floor(revenueCount / totalPricePerOne) : 0);
    const uniqOrders =
      crowdfundData?.lastUsers +
      (revenueCount ? Math.floor(revenueCount / totalPricePerOne) : 0);
    const hasItems = !selectedProducts?.filter(({ checked }) => checked).length;
    const isCampaignDisabled = product?.isCampaignDisabled?.value === "true";
    return (
      <Box
        mt={[7, 7]}
        borderRadius={"8px"}
        p="20px"
        position={"relative"}
        backgroundColor={content?.stroke_color?.color || color}
        width="100%"
        mb={4}
        {...props}
      >
        <Box
          display={"flex"}
          mt={product?.preorderDiscount?.value ? [1, 0] : 0}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Text
            fontFamily={"DINPro"}
            fontWeight={700}
            fontSize={["20px", "24px"]}
          >
            Pre-order: {product.title}
          </Text>
          <Box textAlign={"end"} ml={2}>
            <Text color={"#1D1D1BCC"} lineHeight={"19px"} fontSize={"14px"}>
              Prijs
            </Text>
            {!!totalComparePrice && (
              <Text
                textDecoration={"line-through"}
                opacity={"0.5"}
                lineHeight={"24px"}
                fontSize={"20px"}
                fontWeight={500}
              >
                €{totalComparePrice.toFixed(2)}
              </Text>
            )}
            <Text lineHeight={"24px"} fontSize={"20px"} fontWeight={500}>
              €{totalPrice.toFixed(2)}
            </Text>
          </Box>
        </Box>
        <Divider my={2} color={"#1D1D1B1A"} />
        {isLoading || isLoadingProducts ? (
          <Spinner />
        ) : (
          <Box>
            <Box
              display={"flex"}
              justifyContent={"space-between"}
              // alignItems={"center"}
            >
              <Box>
                <Text lineHeight={"16.8px"} fontSize="12px">
                  Opgehaald
                </Text>
                <Text
                  fontSize={["24px", "36px"]}
                  fontWeight={700}
                  lineHeight={["auto", "35px"]}
                  fontFamily={"DINPro"}
                >
                  €{crowdfundData.rased}
                </Text>
              </Box>
              <Box
                mx={"24px"}
                width={"100%"}
                display={["none", "flex"]}
                flexDirection={"column"}
                alignItems={"center"}
                fontSize={"12px"}
              >
                <Text lineHeight={"16.8px"}>{funded}% Gefinancierd</Text>{" "}
                <Box
                  width={"100%"}
                  my={1}
                  borderRadius={"100px"}
                  height={"16px"}
                  backgroundColor={"#1D1D1B1A"}
                >
                  <Box
                    borderRadius={"100px"}
                    height={"16px"}
                    backgroundColor={"black"}
                    width={`${Number(funded) > 100 ? 100 : funded}%`}
                  />
                </Box>
                <Box display={"flex"} lineHeight={"16.8px"}>
                  <Text>{`${orders} orders`}</Text>
                  <Text mx={1}>|</Text>
                  <Text fontWeight={500}>
                    {uniqOrders} Orders in de laatste 24 uur
                  </Text>
                </Box>
              </Box>

              <Box textAlign={"end"}>
                <Text lineHeight={"16.8px"} fontSize="12px">
                  Doel
                </Text>
                <Text
                  fontSize={["24px", "36px"]}
                  fontWeight={700}
                  lineHeight={["auto", "35px"]}
                  fontFamily={"DINPro"}
                >
                  €{targetValue}
                </Text>
              </Box>
            </Box>
            <Box
              display={["block", "none"]}
              borderRadius={"100px"}
              height={"16px"}
              backgroundColor={"#1D1D1B1A"}
            >
              <Box
                borderRadius={"100px"}
                height={"16px"}
                backgroundColor={"black"}
                width={`${Number(funded) > 100 ? 100 : funded}%`}
              />
            </Box>
            <Box
              mt={"6px"}
              display={["flex", "none"]}
              justifyContent={"space-between"}
              fontSize="12px"
            >
              <Text>{funded}% gefinancierd</Text>
              <Box display={"flex"} flexDirection={"column"} textAlign={"end"}>
                <Text>{`${orders} orders`}</Text>
                <Text fontWeight={500}>
                  {uniqOrders} Orders in de laatste 24 uur
                </Text>
              </Box>
            </Box>
          </Box>
        )}
        <Divider my={2} color={"#1D1D1B1A"} />
        <Box
          mb={[1, 2]}
          display={"flex"}
          justifyContent={["space-between"]}
          alignItems={"center"}
        >
          <Box>
            <Text fontWeight={[500, 600]} fontSize={["16px", "18px"]}>
              Tijd resterend
            </Text>{" "}
            {content?.crowdfund_text_enabler && (
              <Text display={["block", "none"]} fontSize={"12px"}>
                {content?.crowdfund_text}
              </Text>
            )}
          </Box>

          {content?.crowdfund_text_enabler && (
            <Text display={["none", "block"]} fontSize={"12px"}>
              {content?.crowdfund_text}
            </Text>
          )}
          <Box backgroundColor={"#1D1D1B1A"} borderRadius={"8px"} p={"8px"}>
            <Timer endDate={endDate} />
          </Box>
        </Box>
        <Divider my={2} color={"#1D1D1B1A"} />
        <Box>
          {!!connectedProducts &&
            connectedProducts.map((item, i) => (
              <CrowdFudningItem
                key={item.id}
                product={item}
                selectedProduct={selectedProducts[i]}
                setSelectedProducts={setSelectedProducts}
              />
            ))}
        </Box>

        <Box width={"100%"} mt={2}>
          <Button
            variant="primary"
            width={"100%"}
            fontSize={["16px", 2.25]}
            height="56px"
            disabled={hasItems || isCampaignDisabled}
            fontWeight={500}
            isLoading={updatingCart}
            onClick={() => {
              posthog.capture("Clicked Add to Cart", {
                source: "Product Page",
                product: product.title,
                properties: {
                  $process_person_profile: false,
                },
              });
              addItemToCart(
                selectedProducts
                  ?.filter(({ checked }) => checked)
                  .map(({ id, quantity }) => ({
                    quantity,
                    merchandiseId: id,
                  })),
                () => {
                  if (!content.isUpsellDisabled) showModal(true);
                }
              );
            }}
            flex={1}
            px={[0, "initial"]}
          >
            {hasItems ? (
              <Text>Kies de producten</Text>
            ) : isCampaignDisabled ? (
              <Text>Crowdfunding volgeschreven</Text>
            ) : (
              <>
                <Text mr={"3px"}>Pre-order nu </Text>
                <Text>{`-- €${totalPrice.toFixed(2)}`}</Text>
              </>
            )}
          </Button>
        </Box>
        {product.preorderDiscount?.value && (
          <Box
            top={-2.5}
            border={"1px solid #E2DFDF"}
            borderRadius={"5px"}
            backgroundColor={"white"}
            px={["13px", "17px"]}
            py="10px"
            fontWeight={700}
            mx={"auto"}
            left={[0, "auto"]}
            right={[0, "auto"]}
            width={"max-content"}
            fontSize={["12px", "14px"]}
            letterSpacing={1}
            fontFamily={"DINPro"}
            position={"absolute"}
          >
            {`PRE-ORDER EN KRIJG ${product.preorderDiscount.value}% KORTING`}
          </Box>
        )}
        <UpsellModal
          isOpen={modal}
          close={() => showModal(false)}
          product={product}
        />
      </Box>
    );
  }
);
